export const getGridFromState = (state, name) => {
  return state[name]
}

export default getGridFromState



// WEBPACK FOOTER //
// ./src/modules/Framework/Grid/Helpers/getGridFromState.js